export default "__VITE_ASSET__BQpx6fKB__"